import React, { useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { Tag, Tooltip, Typography } from 'antd';
import { CloseOutlined } from '@ant-design/icons';

import { safeExtractFromObject } from '../helpers/helpers';

import Colors from '../constants/Colors';

const COLOR_MAP = {
  darkgreen: 'white',
  red: '#f5222d',
  orange: '#fa8c16',
  blue: '#1890ff',
  green: '#52c41a',
  purple: '#722ed1',
  cyan: '#13c2c2',
  gray: '#8c8c8c',
  black: '#000000',
  white: '#ffffff',
  default: Colors.REDESIGN_PRIMARY_TEXT,
};

// Helper function to determine text color based on background
// Default text colors for specific backgrounds

const getTextColor = (backgroundColor) => (
  COLOR_MAP[backgroundColor] ?? COLOR_MAP.default
);

function OntraccrTag(props) {
  const settings = useSelector((state) => safeExtractFromObject(state, 'settings.company.settings'));

  const [isTruncated, setIsTruncated] = useState(false);

  const hasRedesign = settings?.uxRedesignPt1;
  const {
    className,
    color,
    closeIcon,
    closable,
    children,
    textStyle,
    needsBorder,
    size,
    ...rest
  } = props ?? {};
  let fullClassname = className;
  let actualCloseIcon = closeIcon;
  if (hasRedesign) {
    fullClassname = size === 'small' ? 'ontraccr-tag-small' : 'ontraccr-tag';
    if (!color) {
      fullClassname += ' ontraccr-tag-default-background';
    }
    if (needsBorder) fullClassname += ' ontraccr-tag-border';
    if (className) fullClassname += ` ${className}`;
    if (!closeIcon && closable) {
      actualCloseIcon = (
        <CloseOutlined
          style={{
            color: Colors.REDESIGN_BUTTON_UNSELECTED_TEXT,
            fontSize: 12,
            marginLeft: 4,
          }}
        />
      );
    }
  }
  const body = useMemo(() => {
    if (!hasRedesign) return children;
    if (typeof children !== 'string') return children;
    return (
      <Tooltip
        destroyTooltipOnHide
        placement="top"
        title={isTruncated ? children : undefined}
      >
        <Typography.Paragraph
          style={{
            maxWidth: closable ? 160 : 200,
            display: 'inline-block',
            color: color ? getTextColor(color) : Colors.REDESIGN_PRIMARY_TEXT,
            ...textStyle,
          }}
          ellipsis={{
            rows: 1,
            onEllipsis: setIsTruncated,
          }}
        >
          {children}
        </Typography.Paragraph>
      </Tooltip>
    );
  }, [
    children,
    isTruncated,
    hasRedesign,
    actualCloseIcon,
    closable,
    color,
    textStyle,
    size,
  ]);
  return (
    <Tag
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...rest}
      color={color}
      closable={closable}
      className={fullClassname}
      closeIcon={actualCloseIcon}
    >
      {body}
    </Tag>
  );
}

export default OntraccrTag;
